import type { SupportedLanguages } from '@sydle/sydle-one-components/';
import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface GetInternationalizedContentInput {
  serviceId: string;
  scope?: 'PREVIEW' | 'CONTENT';
}

export interface GetInternationalizedContentOutput {
  contentFormat?: 'MARKDOWN' | 'HTML';
  content?: { [key: string]: string };
  supportedLanguages?: SupportedLanguages[];
}

export async function getInternationalizedContent(
  input: GetInternationalizedContentInput,
): Promise<FetchResponse<GetInternationalizedContentOutput>> {
  return await portalCustomAPI.fetch<GetInternationalizedContentInput, GetInternationalizedContentOutput>(
    'getInternationalizedContent',
    input,
  );
}
